<template>

    <div>
        <div v-if="review">
            <div class="w3-col w3-margin-bottom">
                <h4 class="flow-blue-color zero-bottom">
                    {{ $t("reviewAccountUpdate") }}
                </h4>
                <p class="zero-top">
                    <span class="w3-text-deep-orange w3-col font-weight-bold">
                        <i class="fa fa-exclamation-circle"></i>
                        {{ $t("wardBeforeAccountUpdate") }}
                    </span>
                </p>
            </div>

            <div class="w3-border w3-col"></div>

            <div v-if="isPower" class="w3-col">
                <p class="w3-col flow-form-inline-input">
                    <label class="flow-blue-color">{{ $t("wards") }}</label>
                </p>
                <p class="flow-form-inline-input zero-top">
                    <span v-if="selectedWards" class="w3-margin">
                            {{ selectedWards }}
                        </span>
                    <span v-else class="w3-margin w3-text-deep-orange">
                        {{ $t('none') }}
                    </span>
                </p>
            </div>

            <div class="w3-col">
                <p class="w3-col flow-form-inline-input">
                    <label class="flow-blue-color">
                        <span>
                            {{ isPhysician ? $t('youAreAPhysician') : $t('youAreACareProvider') }}
                        </span>
                    </label>
                </p>
            </div>

            <div class="w3-col">
                <p class="w3-col flow-form-inline-input">
                    <label class="flow-blue-color">
                        {{ $t("physician") }}
                    </label>
                </p>

                <span v-if="addNewPhysician">
                    <span class="w3-tag w3-round-medium w3-deep-purple">New</span>
                    <p class="flow-form-inline-input zero-top">
                        <physician-entry :physician="newPhysicianObj()"/>
                    </p>
                </span>

                <span v-else-if="selectedPhysician">
                    <p class="flow-form-inline-input zero-top">
                        <physician-entry :physician="selectedPhysician"/>
                    </p>
                </span>

                <span v-else>
                    <p class="flow-form-inline-input zero-top">
                        <span class="w3-margin w3-text-deep-orange">
                            {{ $t('none') }}
                        </span>
                    </p>
                </span>
            </div>

            <div class="w3-col zero-top w3-center">
                <p class="flow-form-inline-input">
                    <button class="flow-btn w3-btn w3-round w3-border w3-round-medium"
                            @click.prevent="review = false">
                        <i class="fa fa-arrow-left w3-text-deep-orange">
                            <span><b class="flow-margin-left">{{$t('back')}}</b></span>
                        </i>
                    </button>
                </p>

                <p class="flow-form-inline-input">
                    <button class="flow-btn w3-btn w3-round w3-border w3-round-medium"
                            @click.prevent="validateAndSave">
                        <i class="fa fa-save flow-green-active-color">
                            <span><b class="flow-margin-left">{{$t('save')}}</b></span>
                        </i>
                    </button>
                </p>
            </div>

        </div>

        <form v-else class="flow-form-cum-panel">
            <h3 class="flow-blue-color w3-margin font-weight-bold">
                {{ $t("accountDetails") }}
            </h3>

            <div class="w3-border w3-col"></div>

            <div v-if="isPower" class="w3-col">
                <p class="w3-col flow-form-inline-input">
                    <label class="flow-blue-color">{{ $t("select.wards") }}</label>
                    <span class="w3-text-red w3-padding-small">
                        <small>
                            ({{ $t("required") }})
                        </small>
                    </span>

                    <label v-for="ward in allWards" class="flow-radio w3-col w3-margin">
                        <input class="w3-input" type="checkbox" v-bind:value="ward.id" v-model="wardIds"/>
                        <span class="name w3-padding-large">{{ ward.displayName }}</span>
                        <i class="square fa fa-check"></i>
                    </label>
                </p>
            </div>

            <div class="w3-border w3-border-light-gray w3-col w3-center"></div>

            <div class="w3-col">
                <p class="w3-col flow-form-inline-input">
                    <label class="flow-blue-color">
                        {{ $t('whoArtThou') }}
                    </label>

                    <label class="flow-radio w3-margin">
                        <input class="w3-input" type="radio" name="isAGSPhysician" v-bind:value=true v-model="isPhysician"/>
                        <span class="name w3-padding-large">
                            {{ $t('immaPhysician') }}
                        </span>
                        <i class="dot far fa-dot-circle"></i>
                    </label>
                    <label class="flow-radio w3-margin">
                        <input class="w3-input" type="radio" name="isAGSPhysician" v-bind:value=false v-model="isPhysician"/>
                        <span class="name w3-padding-large">
                            {{ $t('immaCareProvider') }}
                        </span>
                        <i class="dot far fa-dot-circle"></i>
                    </label>
                </p>
            </div>

            <div class="w3-border w3-border-light-gray w3-col w3-center"></div>

            <div class="w3-col">
                <p class="w3-col flow-form-inline-input">
                    <label class="flow-blue-color">
                        {{ $t("physician") }}
                        ({{ $t("selectOnlyIfAgendaUser") }})
                    </label>
                    <span v-if="isNormal" class="w3-text-red w3-padding-small">
                        <small>
                            ({{ $t("required") }})
                        </small>
                    </span>
                </p>

                <div v-if="addNewPhysician" class="w3-margin">
                    <p class="w3-col w-70pc flow-form-inline-input">
                        <label class="flow-blue-color">{{ $t("screenName") }}</label>
                        <input class="w3-input flow-margin-top" v-bind:placeholder="$t('enter.screenName')" v-model="newPhysician.name" v-bind:class="newPhysicianError.name ? 'error' : ''">
                    </p>

                    <p class="w3-col w-70pc flow-form-inline-input">
                        <label class="flow-blue-color">{{ $t("externalId") }}</label>
                        <input class="w3-input flow-margin-top" v-bind:placeholder="$t('enter.externalId')" v-model="newPhysician.ref"
                               v-bind:class="newPhysicianError.ref ? 'error' : ''">
                    </p>
                    <p class="w3-col w-70pc flow-form-inline-input">
                        <label class="flow-blue-color">{{$t('ward')}}</label>
                        <flow-select class="flow-margin-top" :items="allWards" :valueKey="'displayName'" :valueKeyIndex="'id'" :callback="setNewPhysicianWardId"></flow-select>
                    </p>

                    <p class="w3-col flow-form-inline-input">
                        <button class="flow-btn w3-btn w3-border w3-round-medium" @click.prevent="addNewPhysician = false">
                            <i class="fa fa-arrow-left w3-text-deep-orange">
                                <span><b class="flow-margin-left">{{$t('back')}}</b></span>
                            </i>
                        </button>
                    </p>
                </div>


                <div v-else class="w3-margin">
                    <p class="w3-col flow-form-inline-input">
                        <input class="w3-input flow-margin-bottom" v-model="physicianSearchKey" :placeholder="$t('searchPhysiciansPlaceholder')">
                    </p>

                    <p v-if="selectedPhysician" class="w3-col flow-form-inline-input zero-top zero-bottom flow-blue-color">
                        <physician-entry class="zero-left" :physician="selectedPhysician"></physician-entry>
                    </p>

                    <p v-if="physicians"
                       class="w3-col flow-form-inline-input w3-border w3-round-medium"
                       style="height: 200px !important; overflow-y: scroll; overflow-x: hidden">
                        <label v-for="physician in filteredPhysicians"
                               class="flow-radio w3-margin w3-border w3-round-medium w3-padding-large w3-hover-light-gray" @click="selectedPhysician = physician">
                            <input class="w3-input" type="radio" name="physicianId" v-bind:value=physician.id v-model="physicianId"/>
                            <physician-entry :physician="physician"></physician-entry>
                            <i class="dot far fa-dot-circle w3-margin-left"></i>
                        </label>

                        <span class="flow-blue-color w3-col w3-center w3-margin w3-padding-large">
                            <span v-if="isPhysician && physicians && filteredPhysicians.length === 0">
                                <label class="w3-col w-100pc">
                                    {{ $t("noCanFind?") }}
                                </label>
                                <button class="w3-margin flow-btn w3-btn w3-border w3-round-medium" @click.prevent="addNewPhysician = true">
                                    <i class="fa fa-plus flow-green-active-color"></i>
                                    {{ $t("addNewPhysician") }}
                                </button>
                            </span>
                            <span v-else-if="filteredPhysicians.length === 0">
                                <label>
                                    {{ $t("noPhysicians") }}
                                </label>
                            </span>
                        </span>
                    </p>
                </div>
            </div>

                <div class="w3-container zero-top">
                    <p class="flow-form-inline-input">
                        <button class="flow-btn w3-btn w3-round w3-border w3-round-medium"
                                @click.prevent="review = true">
                            <i class="fa fa-arrow-right flow-green-active-color">
                                <span><b class="flow-margin-left">{{ $t("next") }}</b></span>
                            </i>
                        </button>
                    </p>
                </div>

            </form>

    </div>

</template>

<script>
    import Vue from 'vue';
    import FlowSelect from "../../components/common/FlowSelect";
    import PhysicianEntry from "./PhysicianEntry";
    const frc = Vue.prototype.$frc;

    export default {
        name: "AccountForm",
        components: {PhysicianEntry, FlowSelect},
        props: ["onSave"],
        data() {
            return {
                userInfo: undefined,
                isPhysician: false,
                physicianId: undefined,
                wardIds: [],
                physicians: undefined,
                physicianSearchKey: undefined,
                addNewPhysician: false,
                accountSaved: false,
                allWards: [],
                selectedPhysician: undefined,
                newPhysician: {
                    ref: undefined,
                    name: undefined,
                    wardId: undefined,
                    ward: undefined
                },
                newPhysicianError: {
                    ref: undefined,
                    name: undefined
                },
                review: false
            }
        },
        watch: {
            addNewPhysician(newVal) {
                if (newVal === true) {
                    this.selectedPhysician = undefined;
                    this.physicianId = undefined;
                }
            }
        },
        computed: {
            isPower() {
                return Vue.isPower(this.user.role);
            },
            isNormal() {
                return Vue.isNormal(this.user.role);
            },
            role() {
                 return this.user.role;
            },
            user() {
                return this.userInfo === undefined ? {} : this.userInfo.user;
            },
            filteredPhysicians() {
                if (!this.physicianSearchKey || !this.physicianSearchKey.trim()) {
                    return this.physicians;
                }

                var regex = new RegExp(this.physicianSearchKey, 'i');
                return this.physicians.filter(function(phy) {
                    if (phy.name.match(regex)) {
                        return true;
                    }

                    if (phy.agendaSystemIds) {
                        for (var idx in phy.agendaSystemIds) {
                            if (phy.agendaSystemIds[idx].match(regex)) {
                                return true;
                            }
                        }
                    }

                    return false;
                });
            },
            selectedWards() {
                if (!this.wardIds || this.wardIds.length < 1) {
                    return undefined;
                }

                var wards = [];
                const app = this;

                this.allWards.forEach(function(w) {
                    if (app.wardIds.includes(w.id)) {
                        wards.push(w.displayName);
                    }
                });

                return wards.join(",");
            }
        },
        mounted() {
            const app = this;
            frc.getCurrentUser().then(function (res) {
                app.userInfo = res.data.overview;
            });

            frc.getAllPhysicians().then(function (res) {
                app.physicians = res.data;
            });

            frc.getWards().then(function (res) {
                app.allWards = res.data;
            });
        },
        methods: {
            validateAndSave() {
                const request = {
                    AGSPhysician: this.isPhysician,
                    agsPhysicianId: this.physicianId
                };
                if (this.addNewPhysician === true) {
                    request.newPhysician = {
                        screenName: this.newPhysician.name,
                        wardId: this.newPhysician.wardId,
                        agsId: this.newPhysician.ref
                    }
                }
                if (this.isPower) {
                    request.wardIds = this.wardIds;
                }

                this.newPhysicianError.ref = undefined;
                this.newPhysicianError.name = undefined;

                const app = this;
                frc.updateSelfAccount(request).then(function (res) {
                    app.onSave();
                }).catch(function (ex) {
                    app.review = false;

                    if (!ex.restCodes) {
                        return;
                    }

                    if (ex.restCodes.includes("INVALID_REFERENCES") || ex.restCodes.includes("AGENDA_SYSTEM_REFERENCES_EXISTS")) {
                        app.newPhysicianError.ref = true;
                    }

                    if (ex.restCodes.includes("INVALID_SCREEN_NAME")) {
                        app.newPhysicianError.name = true;
                    }
                });
            },
            setNewPhysicianWardId(ward) {
                this.newPhysician.wardId = ward.id;
            },
            newPhysicianObj() {
                var obj = {
                    name: this.newPhysician.name,
                    agendaSystemIds: [this.newPhysician.ref],
                    ward: {}
                };

                var wid = this.newPhysician.wardId;
                for (var idx in this.allWards) {
                    const w = this.allWards[idx];
                    if (w.id === wid) {
                        obj.ward = w;
                        break;
                    }
                }

                return obj;
            }
        }


    }
</script>

<style scoped>

</style>